import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'ProprietaryFertilizer',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'FieldAdvice', //not a typo
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl, IETFLocales.en],
  PRODUCTION: true,
  AZURE_MAPS_SUBSCRIPTION_KEY: 'dcBP1s64SFNCvQpGOQx0_MQT8xHbM1ec8Vah8_5EnrE',
  AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: 'dcBP1s64SFNCvQpGOQx0_MQT8xHbM1ec8Vah8_5EnrE',
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  SHOP_URL: 'https://webshop.agrifirm.com',
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  KUBE_CONTAINER_NAME: '',
  KUBE_NODE_NAME: '',
  KUBE_POD_NAME: '',
  KUBE_TEAM: '',
  SHOW_CART_ICON: true,
  DELIVERY_TIME_WINDOW_DISABLED: true,
  SHOW_DISABLED_LOCATION_BADGE: true,
  SUBSCRIBE_TO_CART_EVENTS: true,
  IS_MY_PROSPECTS_HIDDEN: true,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
  FIELD_ADVICE_URL: 'https://field-advice.agrifirm.com',
};
